import { Button, makeStyles, useAnnounce } from '@fluentui/react-components';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDefaultModalStyles } from '../../hooks/useDefaultModalStyles';
import Modal from './ModalV9';

export interface IReturnHasBeenDeletedNotificationModalProps {
    isModalVisible: boolean;
    onConfirm: () => void;
}

const MAX_Z_INDEX_VALUE = 2147483647;

const useStyles = makeStyles({
    message: {
        maxWidth: '550px',
    },
});

const ReturnHasBeenDeletedNotificationModal = ({ isModalVisible, onConfirm }: IReturnHasBeenDeletedNotificationModalProps) => {
    const { t } = useTranslation();
    const { message } = useStyles();
    const { button } = useDefaultModalStyles();
    const { announce } = useAnnounce();
    const redirectMessage = t('calcDeletedRedirectMessage').toString();

    useEffect(() => {
        if (!isModalVisible) {
            return;
        }
        announce(redirectMessage, { alert: true, batchId: 'return-deleted-notification' });
    }, [isModalVisible, redirectMessage, announce]);

    return (
        <Modal
            headerContent={t('calcDeletedByAnotherUser')}
            bodyContent={<div className={message}>{redirectMessage}</div>}
            isOpen={isModalVisible}
            onClose={() => {}}
            buttons={
                <Button
                    size='small'
                    aria-label={t('returnToAllCalculations').toString()}
                    onClick={onConfirm}
                    data-testid='confirm-delete-return-notification'
                    className={button}
                >
                    {t('returnToAllCalculations').toString()}
                </Button>
            }
            showModalCloseButton={false}
            isBlocking={true}
            zIndex={MAX_Z_INDEX_VALUE}
        />
    );
};

export default ReturnHasBeenDeletedNotificationModal;
